import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UzurvPipesModule } from '@uzurv/core';
import { GenericSearchComponent } from './generic-search.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, MatInputModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, UzurvPipesModule],
  exports: [GenericSearchComponent],
  declarations: [GenericSearchComponent]
})
export class GenericSearchModule {}
